module.exports = {
  development: 'https://content-platform-development.sephora-asia.dev/api/v1/',
  staging: 'https://content-platform-staging.sephora-asia.dev/api/v1/',
  production: 'https://content-platform.sephora.sg/api/v1/'
}
